import { ActionType, getType } from 'typesafe-actions';

import * as CartAction from '../actions/CartAction';

const defaultState = {
  count: null,
  visible: false,
};

export default function cart(
  state: Cart = defaultState,
  action: ActionType<typeof CartAction>
): Cart {
  switch (action.type) {
    case getType(CartAction.addCartItem):
      return {
        ...state,
        count: state.count != null ? state.count + 1 : state.count,
      };
    case getType(CartAction.removeCartItem): {
      return {
        ...state,
        count: state.count != null ? state.count - 1 : state.count,
      };
    }
    case getType(CartAction.updateCartCount): {
      return { ...state, count: action.payload };
    }
    case getType(CartAction.toggleCart): {
      return { ...state, visible: !state.visible };
    }
    default:
      return state;
  }
}
